export const type = 'form.divider';
